export const sansSerif = `'Montserrat', 'Oxygen', 'Lato', -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Ubuntu,sans-serif`
export const serif = `'Crete Round', 'PT Serif', 'Constantia', 'Georgia', serif`
